import axios from 'axios';
import {
  COUNT_APPLICATION_DOCUMENTS_URL,
  get_headers, GET_APPLICATION_DOCUMENTS, COUNT_SUB_ENTITIES_URL
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import FilePreviewComponent from "@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue";

export default {
  mixins: [alert_mixin],
  components: {
    FilePreviewComponent
  },

  data: () => ({
      entity_name: sessionStorage.getItem('entity_name'),
      showAlert: true,
      metrics: [
        {
          label: 'Active Employees',
          value: 0,
          icon: 'bx bx-group me-1 text-white',
          iconBg: 'bg-secondary bg-opacity-25'
        },
        {
          label: 'Supplier Documents',
          value: 0,
          icon: 'bi bi-file-earmark-text text-white',
          iconBg: 'bg-secondary bg-opacity-25'
        },
      ],
      meetings: [
        {
          id: 2,
          type: 'Annual General Meeting',
          title: 'Annual General Meeting',
          date: '15 Feb 2025',
          time: '10:00 AM',
          badgeClass: 'bg-success-subtle text-success'
        },
        {
          id: 3,
          type: 'Special Meeting',
          title: 'Special Resolution - Amendment',
          date: '22 Feb 2025',
          time: '10:00 AM',
          badgeClass: 'bg-warning-subtle text-warning'
        }
      ],
      document_counts_loading: false,
      document_counts: {
        application_documents: 0,
        submission_documents: 0,
        journal_documents: 0,
        additional_documents: 0,
        total_documents: 0,
      },
      recentDocuments: [],

      // File preview state
      show_file_preview: false,
      preview_file_url: '',
      preview_file_name: '',
      recent_documents_loading: false,
      is_loading_stats: false,
      sub_entity_stats: {
        total: 0,
        active: 0,
      },
  }),

  mounted() {
    this.fetch_document_counts();
    this.fetch_recent_documents();
    this.fetch_sub_entity_stats();
  },
  methods: {

    viewCalendar() {
      // calendar logic
    },

    view_all_documents() {
      sessionStorage.setItem('active_tab', 'Documents');
      sessionStorage.setItem('active_master_tab', 'documents');
      sessionStorage.setItem('came_from_dashboard', 'true');

      this.$router.push({
        path: '/entity_application_overview',
        query: {
          application_id: sessionStorage.getItem('application_id'),
          entity_profile_id: sessionStorage.getItem('entity_profile_id'),
          entity_type_id: sessionStorage.getItem('entity_type_id'),
        }
      });
    },

    fetch_document_counts() {
      const application_id = Number(sessionStorage.getItem('application_id') || 0);
      if (!application_id) return;

      this.document_counts_loading = true;

      axios.get(COUNT_APPLICATION_DOCUMENTS_URL, {
        headers: get_headers(),
        params: { application_id },
      })
        .then((response) => {
          const body = response.data;

          if (body?.status === 'success' && body?.data) {
            this.document_counts = { ...body.data };

            const docMetric = this.metrics.find(m => m.label === 'Supplier Documents');
            if (docMetric) {
              docMetric.value = body.data.total_documents;
            }
          } else {
            this.show_error('Unexpected response from document count API:', body);
          }
        })
        .catch((error) => {
          this.show_error(
            'Error fetching document counts:',
            error.response?.data?.message || error.message
          );
        })
        .finally(() => {
          this.document_counts_loading = false;
        });
    },

    fetch_recent_documents() {
      const application_id = sessionStorage.getItem('application_id');
      if (!application_id) return;

      this.recent_documents_loading = true;

      axios.get(GET_APPLICATION_DOCUMENTS, {
        headers: get_headers(),
        params: { application_id },
      })
        .then((response) => {
          const docs = response.data?.data || [];

          this.recentDocuments = docs
            .sort((a, b) => new Date(b.submitted_on) - new Date(a.submitted_on))
            .slice(0, 3)
            .map(doc => ({
              name: doc.file_name,
              date: new Date(doc.submitted_on).toLocaleDateString(),
              presigned_url: doc.presigned_url,
            }));
        })
        .catch((error) => {
          this.show_error('Error loading recent documents: ' + (error.response?.data?.message || error.message));
        }).finally(() => {
          this.recent_documents_loading = false;
        });
    },

    open_file_preview(doc) {
      this.preview_file_url = doc.presigned_url;
      this.preview_file_name = doc.name;
      this.show_file_preview = true;
    },

    close_file_preview() {
      this.show_file_preview = false;
      this.preview_file_url = '';
      this.preview_file_name = '';
    },

    fetch_sub_entity_stats() {
      const entity_profile_id = sessionStorage.getItem('entity_profile_id');
      if (!entity_profile_id) return;

      this.is_loading_stats = true;

      axios.get(COUNT_SUB_ENTITIES_URL, {
        headers: get_headers(),
        params: { entity_profile_id },
      })
        .then((response) => {
          if (response.data?.status === 'success') {
            this.sub_entity_stats.total = response.data.sub_entity_count || 0;
            this.sub_entity_stats.active = response.data.active_sub_entity_count || 0;

            // Update the metric value reactively
            const empMetric = this.metrics.find(m => m.label === 'Active Employees');
            if (empMetric) empMetric.value = this.sub_entity_stats.total;
          }
        })
        .catch((err) => {
          this.show_error('Failed to load employee stats:', err);
        })
        .finally(() => {
          this.is_loading_stats = false;
        });
    },

  }
};